import type { RuleSeverity } from '../services/dental-treat-rule-from-eprohis.service';

export class toothTreatPosDto {
    /** 牙位代碼 ex. 11, 12...84, 85 */
    posNo: string;
    /** 牙齒治療紀錄 */
    treatRecord: toothTreated;
}

export class toothTreated {
    /** 不可補牙的牙面位置 OD. ex. c, r, l, u, b */
    cantOD: string[];
    /** 每個不可補牙牙面的規則嚴重度 */
    cantODSeverity?: Record<string, RuleSeverity>;
    /** 可做 ENDO (根管治療)  */
    canENDO: boolean;
    canENDOSeverity?: RuleSeverity;
    /** 可拔牙 Extraction */
    canExt: boolean;
    canExtSeverity?: RuleSeverity;
    /** 可溝縫封填 Sealant */
    canSea: boolean;
    canSeaSeverity?: RuleSeverity;
}

export type ToothHistoryDataSource = 'internal' | 'ic' | 'cloud';

export type ToothTreatPositionLayers = Record<ToothHistoryDataSource, toothTreatPosDto[]>;

export type ToothMarkerTooltipSource = 'internal' | 'external';
export type ToothMarkerTooltipLayer = ToothHistoryDataSource | 'manual';

export interface ToothMarkerTooltipEntry {
    source: ToothMarkerTooltipSource;
    toothPos?: string;
    procedureCode?: string;
    surfaceCodes?: string;
    date: string;
    severity: RuleSeverity;
    layers: ToothMarkerTooltipLayer[];
}

export type ToothMarkerTooltipMap = Record<string, ToothMarkerTooltipEntry[]>;

export interface ToothManualAnnotation {
    cariesFaces: string[];
    cantODFaces: string[];
    cantSeaFaces: string[];
    missing: boolean;
    extracted: boolean;
    impactionTooth: boolean;
    impactionAngle: number;
    residualRoot: boolean;
    periodontitis: boolean;
    abscess: boolean;
    fracture: boolean;
    crown: boolean;
    pontic: boolean;
    implant: boolean;
    prostheticConnections?: string[];
    post: boolean;
    veneer: boolean;
    inlay: boolean;
    displayToothPos?: string;
    isSupernumerary?: boolean;
}

export type ToothManualAnnotationMap = Record<string, ToothManualAnnotation>;

export interface SupernumeraryTooth {
    id: string;
    displayToothPos: '19' | '29' | '39' | '49';
    templateToothPos: string;
    betweenToothPositions?: [string, string];
    x: number;
    y: number;
}
